import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import languages from "../../../../assets/languages.json";
import { ApiService } from "../../../../../../shared/src";
import { CoreService } from "../../../../../../shared/src/lib/services/core.service";
import { SnackbarService } from "../../../../../../shared/src/lib/services/snackbar.service";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { StorageService } from "../../../../../../shared/src/lib/services/storage.service";

@Component({
  selector: "app-language-selector",
  imports: [MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, ReactiveFormsModule, MatProgressBarModule, TranslateModule],
  templateUrl: "./language-selector.component.html",
  styleUrl: "./language-selector.component.scss",
})
export class LanguageSelectorComponent {
  form: FormGroup;
  loader = inject(LoaderService);
  langList = languages;
  apiService = inject(ApiService);
  coreService = inject(CoreService);
  snackbar = inject(SnackbarService);
  locale = this.coreService.getLocale();
  storage = inject(StorageService);

  constructor(
    private fb: FormBuilder,
    public bottomSheetRef: MatBottomSheetRef,
  ) {
    this.form = this.fb.group({
      language: [this.locale],
    });
  }

  handleSubmit() {
    // console.log(this.form.value);

    if (this.form.valid) {
      const authToken = this.apiService.getUserToken();
      const accessToken = authToken?.access_token;

      const data = {
        LANGUAGE: this.form.value.language,
        session_id: accessToken,
      };

      this.coreService.updateLanguage(data).subscribe({
        next: (response: any) => {
          // console.log(response);
          if (response?.status === "ok") {
            this.snackbar.openSnackbar({
              message: "Language updated successfully!",
            });
            // sessionStorage.setItem("locale", this.form.value.language);
            this.storage.setItem("locale", this.form.value.language);
            window.location.reload();
            this.form.reset();
            this.bottomSheetRef.dismiss();
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    } else {
      console.warn("Form is not valid:", this.form.errors);
    }
  }
}
